module.exports = __webpack_public_path__ + "static/DTT_Roues-73f7cdd2665a59948e0b0da4a843016d.svg";